// CompositionAPI导入的生命周期需要注册，mixin进行全局注册
import config from '@/common/config.js'
import { isTrue, isEmpty, isNull, canIUse } from '@/util/is.js'
import { copy, preview } from '@/util/tool.js'
import { usePlatform } from '@/hooks/useSystemInfo.js'

export default {
	data() {
		return {
			appName: config.appName,
			canDisplay: !(
				(usePlatform().isIOS && usePlatform().apiPlatform === 'wx') ||
				(usePlatform().apiPlatform === 'dy')
			),
		}
	},
	methods: {
		isTrue,
		isEmpty,
		isNull,
		copy,
		preview,
		canIUse,
	},
	onShareAppMessage() {
		return {
			desc: "学知识，学技能",
			title: `学知识就上${config.appName}`
		}
	},
	onShareTimeline() {
		return {
			desc: "学知识，学技能",
			title: `学知识就上${config.appName}`
		}
	}
}